import React from "react";
import PropTypes from "prop-types";
import Paste from "./Paste"
import Add from "./Add"
import Reset from "./Reset"

const Controls = (props) => {
  return (
    <div className = "controls">
      <Paste />
      <Add addGrades = {props.addGrades}/>
      <Reset resetGrades = {props.resetGrades}/>
    </div>
  );
};

Controls.propTypes = {};

export default Controls;
